import {FormInterface} from "./Form.interface";

export const FormSchema: FormInterface = {
    isLoading: true,
    isFormChanged: false,
    fields: {
        eventId: {
            label: '',
            placeholder: '',
            value: null,
            error: null,
            isDisabled: true,
            isRequired: true,
            isLoading: false,
        },
        promocode: {
            label: 'Промокод',
            placeholder: 'Введите промокод',
            value: '',
            error: null,
            isDisabled: false,
            isRequired: true,
            isLoading: false,
        },
        promocodes: {
            label: 'Промокоды',
            placeholder: 'Введите промокоды',
            value: [],
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        groupId: {
            label: 'Группа (необязательно)',
            placeholder: 'Новое или имеющееся название',
            value: null,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
            variants: {},
        },
        count: {
            label: 'Количество',
            placeholder: '',
            value: 1,
            error: null,
            isDisabled: false,
            isRequired: true,
            isLoading: false,
        },
        size: {
            label: 'Скидка',
            placeholder: '',
            value: 1,
            error: null,
            isDisabled: false,
            isRequired: true,
            isLoading: false,
        },
        typeId: {
            label: 'Тип скидки',
            placeholder: '',
            value: 'fixed',
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
            variants: {
                fixed: 'руб.',
                percent: '%',
            },
        },
        minticket: {
            label: 'Минимальное',
            placeholder: '',
            value: 1,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        maxticket: {
            label: 'Максимальное',
            placeholder: '',
            value: 'Infinity',
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        minsum: {
            label: 'Минимальная',
            placeholder: '',
            value: 0,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        maxsum: {
            label: 'Максимальная',
            placeholder: '',
            value: 'Infinity',
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        autoUse: {
            label: 'Применять автоматически',
            placeholder: '',
            value: false,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        autoUseConsult: {
            label: 'Применять для консультаций',
            placeholder: '',
            value: false,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        useOptions: {
            label: 'Применять для опций',
            placeholder: '',
            value: false,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        isCertificate: {
            label: 'Применять для сертификатов',
            placeholder: '',
            value: false,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        from: {
            label: 'Старт',
            placeholder: '',
            value: '',
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        till: {
            label: 'Окончание',
            placeholder: '',
            value: '',
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        used: {
            label: 'Количество использований',
            placeholder: '',
            value: 0,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        unlimited: {
            label: 'Можно использовать неограниченное кол-во раз',
            placeholder: '',
            value: false,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        }
    }
};
